"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Theme = void 0;
const dayjs_1 = __importDefault(require("dayjs"));
const _1 = require(".");
class Theme extends _1.Service {
    constructor(onemap) {
        super(onemap, 'themesvc');
    }
    checkThemeStatus(req) {
        return __awaiter(this, void 0, void 0, function* () {
            const newReq = req;
            newReq.dateTime = (0, dayjs_1.default)(req.dateTime).format('YYYY-MM-DD[T]HH:mm:ss[:000Z]');
            return this.privateapi('checkThemeStatus', newReq);
        });
    }
    getThemeInfo(req) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.privateapi('getThemeInfo', req);
        });
    }
    getAllThemesInfo(req) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.privateapi('getAllThemesInfo', req);
        });
    }
    retrieveTheme(req) {
        return __awaiter(this, void 0, void 0, function* () {
            const extents = [];
            for (const coord of req.extents) {
                extents.push(...coord);
            }
            const newReq = req;
            newReq.extents = extents.join(',');
            return this.privateapi('retrieveTheme', req);
        });
    }
}
exports.Theme = Theme;
